import { Component, Input, HostListener , ElementRef, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SearchService } from '../search.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { UserAccountService } from '../user-account.service';
import { DeviceDetailsService } from '../device-details.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-employee-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './employee-dropdown.component.html',
  styleUrl: './employee-dropdown.component.scss'
})
export class EmployeeDropdownComponent {
@Input() viewMode;
@Input() searchHotelForm;
@Input() searchForm;
@Output() travelerApplied = new EventEmitter<any>();
ageGroupList = [{ id: 'ADT', value: 'Adult (12 years and above)', label: '(Adult> 12 years and above)',superAdult:false }, { id: 'CHD', value: 'Child(2-11 years)', label: '(Child 2-11 years age)',superAdult:false }, { id: 'INF', value: 'Infant without seat(< 2 years)', label: '(Infant without seat < 2 years age)',superAdult:false }]
  constructor(
  
    private searchService: SearchService,
  
    public translateService: TranslateService,
   
    public ngxSmartModalService: NgxSmartModalService,
    public userAccountInfoService: UserAccountService,
    public deviceDetailsService: DeviceDetailsService,
   
    private toastr: ToastrService,
    private elRef: ElementRef,
    ) {
    }

    travelerSearchTerm: string = '';
    guestTravelerExpanded: boolean = false;
    guestCounts = { adult: 0, child: 0, infant: 0 };
    mySelfTraveler: any = null;
    filteredTravelers: any[] = [];
    allTravelers: any[] = [];
    private ageGroupCache = new Map<string, any>(); // Cache to prevent constant re-execution
  ngOnInit() {

    if(this.searchService.previousTab !== this.viewMode){
      this.rebuildAgeGroupArray();
      this.searchService.previousTab = this.viewMode;
    }
    


  if(this.viewMode==='tab2'){
    if (this.isGuestTravelerSelected() && (this.guestCounts.child > 0 || this.guestCounts.infant >0)) {

      let numberOfGuest = this.searchService.employeeEmail.filter(item => item.email==='GUEST');
      const numberOfNonAdultGuests = this.guestCounts.child + this.guestCounts.infant;
      this.searchService.employeeEmail = this.searchService.employeeEmail.filter(item => item.email!=='GUEST');
      numberOfGuest.splice(1, numberOfNonAdultGuests);
      this.searchService.employeeEmail = [...this.searchService.employeeEmail,...numberOfGuest];
      this.guestCounts.child = 0;
      this.guestCounts.infant = 0;
      this.syncGuestAgeGroups();
      }
  }else if(this.viewMode==='tab3'){

      
    if (this.searchService.employeeEmail.length > 1) {
      this.guestCounts.adult=1;
      this.guestCounts.child=0;
      this.guestCounts.infant=0;
      this.searchService.employeeEmail.splice(1);
      }
  }
  }
  ngAfterViewInit(){
    this.initializeTravelers();
  }
  initializeTravelers() {
  const userid = this.userAccountInfoService.getUserEmail();
  this.travelerSearchTerm ='';
  // Initialize employeeEmail array if not exists
  if (!this.searchService.employeeEmail) {
  this.searchService.employeeEmail = [];
  }
  
  // Find current user in employeeOptions to get employeeIdentifier
  const currentUser = (this.searchService.travellerList || []).find(
  traveler => traveler.userId === userid
  );
  
  // Set mySelf traveler
  this.mySelfTraveler = {
  Name: this.translateService.instant('search.Myself'),
  Id: 0,
  id: '',
  dob:currentUser?.dob || '',
  email: userid,
  employeeIdentifier: currentUser?.employeeIdentifier || ''
  };
  
  // Auto-select "My Self" for non-admin/non-travel-manager users
  if (!this.searchService.previousTab && !this.isUserCompanyTravelManager() && !this.userAccountInfoService.isUserCorporateAdmin() && this.searchService.employeeEmail.length === 0) {
  // Check if current user is not already in employeeEmail array
  const currentUserExists = this.searchService.employeeEmail.some(t => t.email === userid);
  
  if (!currentUserExists) {
  // Add current user to employeeEmail
  this.searchService.employeeEmail.push({
  Name: 'search.Myself',
  Id: 0,
  email: userid,
  employeeIdentifier: currentUser?.employeeIdentifier || ''
  });
  
  let duplicTravelerIndex =  this.searchService.employeeEmail.findIndex(e => (e.Name == 'search.Myself' && e.email == undefined));
  if (duplicTravelerIndex > -1) {this.searchService.employeeEmail.splice(duplicTravelerIndex, 1);}

  // Initialize ageGroupArray with default Adult if empty
  if (!this.searchService.ageGroupArray) {
  this.searchService.ageGroupArray = [];
  }
  if (this.searchService.ageGroupArray.length === 0) {
  const defaultAgeGroup = JSON.parse(JSON.stringify(this.ageGroupList[0]));
  defaultAgeGroup.superAdult = true;
  this.searchService.ageGroupArray.push(defaultAgeGroup);
  }
  
  // Update passenger count to reflect the change
  this.updatePassengerCount();
  }
  }
  
  // Get all travelers from employeeOptions (excluding already selected ones)
  // Get all travelers except current user and guest
  this.allTravelers = (this.searchService.travellerList || []).filter(
  traveler => traveler.userId !== userid && traveler.userId !== 'GUEST'
  );
  
  // Sort once when modal opens: selected travelers first, then unselected
  this.allTravelers.sort((a, b) => {
  const aSelected = this.isTravelerSelected(a);
  const bSelected = this.isTravelerSelected(b);
  
  // Selected travelers come first
  if (aSelected && !bSelected) return -1;
  if (!aSelected && bSelected) return 1;
  
  // If both selected or both unselected, maintain original order
  return 0;
  });
  setTimeout(() => {
    this.filteredTravelers = [...this.allTravelers];
  })
  
  // Restore guest traveler counts if guest is selected (when editing trip)
  if (this.isGuestTravelerSelected()) {
  this.restoreGuestCounts();
  this.guestTravelerExpanded = true; // Auto-expand guest section
  }
  }
  isUserCompanyManager() {
    return this.userAccountInfoService.isUserCorporateAdmin();
    }
    isUserCompanyTravelManager() {
    return this.userAccountInfoService.isUserIsTravelManager();
    }
  filterTravelers() {
  if (!this.travelerSearchTerm || this.travelerSearchTerm.trim() === '') {
  this.filteredTravelers = [...this.allTravelers];
  return;
  }
  
  const searchTerm = this.travelerSearchTerm.toLowerCase();
  this.filteredTravelers = this.allTravelers.filter(traveler => {
  const name = (traveler.userName || traveler.Name || '').toLowerCase();
  const id = (traveler.id || traveler.Id || traveler.employeeIdentifier || '').toString().toLowerCase();
  return name.includes(searchTerm) || id.includes(searchTerm);
  });
  }
  
  toggleTravelerSelection(traveler: any) {
  if (!traveler) return;
  
  const userid = this.userAccountInfoService.getUserEmail();
  // Handle both mySelfTraveler (has email property) and travellerList items (has userId property)
  const travelerEmail = traveler.email || traveler.userId;
  const index = this.searchService.employeeEmail.findIndex(t =>
  (t.email === travelerEmail) || (t.Id === traveler.id && t.Name === traveler.userName)
  );
  
  if (index > -1) {
  // Deselect - remove from employeeEmail and ageGroupArray
  this.searchService.employeeEmail.splice(index, 1);
  if (this.searchService.ageGroupArray && this.searchService.ageGroupArray.length > index) {
  this.searchService.ageGroupArray.splice(index, 1);
  }
  
  this.filterTravelers();
  
  } else {
  // Check traveler count limits for flight and train tabs
  if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
  if (this.searchService.employeeEmail.length >= environment.maxTravellersForFlight) {
  this.toastr.error(`You can select maximum ${environment.maxTravellersForFlight} travelers`);
  return;
  }
  }
  
  // Check traveler count limits for hotel tab
  if (this.viewMode === 'tab2') {
  if (this.searchService.employeeEmail.length >= environment.maxNumRoomsForHotels) {
  this.toastr.error(`You can select maximum ${environment.maxNumRoomsForHotels} travelers`);
  return;
  }
  }
  
  // For car tab (tab3), only allow one traveler - remove all existing travelers including guest
  if (this.viewMode === 'tab3' && this.searchService.employeeEmail.length > 0) {
  // Check if guest traveler is selected
  const guestIndex = this.searchService.employeeEmail.findIndex(t => t.email === 'GUEST');
  if (guestIndex > -1) {
  // Remove guest traveler
  this.searchService.employeeEmail.splice(guestIndex, 1);
  // Reset guest counts and collapse guest section
  this.guestCounts = { adult: 0, child: 0, infant: 0 };
  this.guestTravelerExpanded = false;
  // Clear guest age groups
  this.syncGuestAgeGroups();
  }
  
  // Remove the existing non-guest traveler
  const nonGuestTravelers = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST');
  if (nonGuestTravelers.length > 0) {
  const existingIndex = this.searchService.employeeEmail.findIndex(t => t.email === nonGuestTravelers[0].email);
  this.searchService.employeeEmail.splice(existingIndex, 1);
  // Remove corresponding age group
  if (this.searchService.ageGroupArray && this.searchService.ageGroupArray.length > existingIndex) {
  this.searchService.ageGroupArray.splice(existingIndex, 1);
  }
  }
  }
  
  // Select - add to employeeEmail and remove from options
  const isCurrentUser = traveler.email === userid || traveler.userId === userid;
  
  if (isCurrentUser) {
  let user ={Name:'',Id:-1,email:''};
  user.Id = 0;
  user.Name = traveler.Name || traveler.userName;
  user.email = traveler.email || traveler.userId;
  this.searchService.employeeEmail.unshift(user);
  } else {
  let user ={Name:'',Id:-1,email:''};
  user.Id = 0;
  user.Name = traveler.userName;
  user.email = traveler.userId;
  this.searchService.employeeEmail.push(user);
  }
  
  // Initialize ageGroupArray if needed
  if (!this.searchService.ageGroupArray) {
  this.searchService.ageGroupArray = [];
  }
  
  // If traveler has DOB, calculate age group automatically
  // Otherwise, leave unselected for user to choose
  const dob = traveler.dob || traveler.dateOfBirth;
  if (dob) {
  const ageGroup = this.calculateAgeGroupFromDOB(dob);
  ageGroup.superAdult = true; // Mark as super adult when selected from modal
  // Add to beginning if current user, end if other user (match employeeEmail order)
  if (isCurrentUser) {
  this.searchService.ageGroupArray.unshift(ageGroup);
  } else {
  this.searchService.ageGroupArray.push(ageGroup);
  }
  } else {
  // No DOB - add placeholder without selecting any age group
  // User must manually select age group
  if (isCurrentUser) {
    this.searchService.ageGroupArray.unshift({ id: null, superAdult: false });
  } else {
    if(this.searchService.infantBookingAllowed){
      this.searchService.ageGroupArray.push({ id: null, superAdult: false });
    }else{
      this.searchService.ageGroupArray.push({id: 'ADT', value: 'Adult (12 years and above)', label: '(Adult> 12 years and above)',superAdult:false });
    }
  }
  }
  
  this.filterTravelers();
  }
  
  // Clear cache to reflect changes
  this.ageGroupCache.clear();
  this.updatePassengerCount();
  }
  
  isTravelerSelected(traveler: any): boolean {
  if (!traveler) return false;
  // Handle both mySelfTraveler (has email property) and travellerList items (has userId property)
  const travelerEmail = traveler.email || traveler.userId;
  return this.searchService.employeeEmail.some(t =>
  (t.email === travelerEmail) || (t.Id === traveler.employeeIdentifier && t.Name === traveler.userName)
  );
  }
  
  canSelectTraveler(traveler: any): boolean {
  // If traveler is already selected, allow (so they can uncheck)
  if (this.isTravelerSelected(traveler)) {
  return true;
  }
  
  // Check limits for flight and train tabs
  if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
  return this.searchService.employeeEmail.length < environment.maxTravellersForFlight;
  }
  
  // Check limits for hotel tab
  if (this.viewMode === 'tab2') {
  return this.searchService.employeeEmail.length < environment.maxNumRoomsForHotels;
  }
  
  // For other tabs, allow selection
  return true;
  }
  
  canSelectGuestTraveler(): boolean {
  // If guest is already selected, allow (so they can uncheck)
  if (this.isGuestTravelerSelected()) {
  return true;
  }
  
  // Check limits for flight and train tabs
  if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  return nonGuestCount < environment.maxTravellersForFlight;
  }
  
  // Check limits for hotel tab
  if (this.viewMode === 'tab2') {
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  return nonGuestCount < environment.maxNumRoomsForHotels;
  }
  
  // For other tabs, allow selection
  return true;
  }
  
  toggleGuestTravelerExpand() {
  
  setTimeout(() => {
  this.toggleGuestTravelerSelection();
  }, 100);
  }
  
  toggleGuestTravelerSelection() {
  const guestIndex = this.searchService.employeeEmail.findIndex(t => t.email === 'GUEST');

  if (guestIndex > -1) {
  // Deselect guest traveler - remove from employeeEmail and reset counts
  this.searchService.employeeEmail = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST');
  // this.searchService.employeeEmail.splice(guestIndex, 1);
  this.guestCounts = { adult: 0, child: 0, infant: 0 };
  this.guestTravelerExpanded = false;
  // Clear guest age groups from ageGroupArray

  this.syncGuestAgeGroups();

  } else {
  // For car tab (tab3), remove all existing travelers before selecting guest
  if (this.viewMode === 'tab3' && this.searchService.employeeEmail.length > 0) {
  // Remove all non-guest travelers
  this.searchService.employeeEmail = this.searchService.employeeEmail.filter(t => t.email === 'GUEST');
  // Clear age groups
  this.searchService.ageGroupArray = [];
  }
  
  // Check traveler count limits for flight and train tabs
  this.guestTravelerExpanded = true;
  if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  // Adding guest with minimum 1 adult
  if (nonGuestCount + 1 > environment.maxTravellersForFlight) {
  this.toastr.error(`You can select maximum ${environment.maxTravellersForFlight} travelers`);
  return;
  }
  }
  
  // Check traveler count limits for hotel tab
  if (this.viewMode === 'tab2') {
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  // Adding guest with minimum 1 adult
  if (nonGuestCount + 1 > environment.maxNumRoomsForHotels) {
  this.toastr.error(`You can select maximum ${environment.maxNumRoomsForHotels} travelers`);
  return;
  }
  }
  
  // Select guest traveler - add to employeeEmail
  const guestTraveler = { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' };
  this.searchService.employeeEmail.push(guestTraveler);

  
  if (this.guestCounts.adult === 0 && this.guestCounts.child === 0 && this.guestCounts.infant === 0) {
  this.guestCounts.adult = 1;
  }
  this.guestTravelerExpanded = true;
  // Update age groups for guest travelers

  this.syncGuestAgeGroups();
  }
  this.updatePassengerCount();

  }
  
  isGuestTravelerSelected(): boolean {
  return this.searchService.employeeEmail.some(t => t.email === 'GUEST');
  }
  
  incrementGuestCount(type: 'adult' | 'child' | 'infant') {
  if(this.searchService.employeeEmail.length > 0 && this.viewMode==='tab3'){
  this.searchService.employeeEmail =[];
  this.guestCounts[type]=0;
  }
  
  // Check traveler count limits for flight and train tabs
  if (this.viewMode === 'tab1' || this.viewMode === 'tab5') {
  // Calculate total travelers: non-guest travelers + all guest counts
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  const totalGuestCount = this.guestCounts.adult + this.guestCounts.child + this.guestCounts.infant + 1; // +1 for the one being added
  const totalTravelers = nonGuestCount + totalGuestCount;
  
  if (totalTravelers > environment.maxTravellersForFlight) {
  this.toastr.error(`You can select maximum ${environment.maxTravellersForFlight} travelers`);
  return;
  }
  }
  
  // Check traveler count limits for hotel tab
  if (this.viewMode === 'tab2') {
  // Calculate total travelers: non-guest travelers + all guest counts
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  const totalGuestCount = this.guestCounts.adult + this.guestCounts.child + this.guestCounts.infant + 1; // +1 for the one being added
  const totalTravelers = nonGuestCount + totalGuestCount;
  
  if (totalTravelers > environment.maxNumRoomsForHotels) {
  this.toastr.error(`You can select maximum ${environment.maxNumRoomsForHotels} travelers`);
  return;
  }
  }
  
  this.guestCounts[type]++;

  
   if(this.canSelectTraveler(false)){
      const guestTraveler = { Name: 'search.GuestTraveler', Id: 1, email: 'GUEST' };
      this.searchService.employeeEmail.push(guestTraveler);
    };
  
  
  // Update age groups for guest travelers
  this.syncGuestAgeGroups();
  this.updatePassengerCount();
  }
  
  
  isDobPresent(traveler){

  if(this.searchService.infantBookingAllowed && (this.viewMode ==='tab1' || this.viewMode ==='tab5') && traveler && traveler.dob){
  if(this.getTravelerAgeGroup(traveler)?.id === 'CHD'){
  return ' (Child)'
  }
  else if(this.getTravelerAgeGroup(traveler)?.id === 'ADT'){
  return ' (Adult)'
  }
  else if(this.getTravelerAgeGroup(traveler)?.id === 'INF'){
  return ' (Infant)'
  }
  }
  return '';
  }
  decrementGuestCount(type: 'adult' | 'child' | 'infant') {
  if (this.guestCounts[type] > 0) {
  this.guestCounts[type]--;
  
  // If all guest counts are 0, remove GUEST from employeeEmail
  
  const guestIndex = this.searchService.employeeEmail.findIndex(t => t.email === 'GUEST');
  if (guestIndex > -1) {
  this.searchService.employeeEmail.splice(guestIndex, 1);
  }
  // this.guestTravelerExpanded = false;
  
  
  // Update age groups for guest travelers
  this.syncGuestAgeGroups();
  this.updatePassengerCount();
  }
  }
  
  syncGuestAgeGroups() {
  // Initialize ageGroupArray if needed
  if (!this.searchService.ageGroupArray) {
  this.searchService.ageGroupArray = [];
  }
  
  // Find how many non-guest travelers we have
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  
  // Remove any existing guest age groups (everything after non-guest travelers)
  this.searchService.ageGroupArray = this.searchService.ageGroupArray.slice(0, nonGuestCount);
  
  // If guest traveler is selected, add age groups for each guest passenger
  if (this.isGuestTravelerSelected()) {
  // Add adults
  for (let i = 0; i < this.guestCounts.adult; i++) {
  const adultAgeGroup = JSON.parse(JSON.stringify(this.ageGroupList.find(item => item.id === 'ADT')));
  adultAgeGroup.superAdult = true; // Guest travelers are not marked as super adult
  this.searchService.ageGroupArray.push(adultAgeGroup);
  }
  
  // Add children
  for (let i = 0; i < this.guestCounts.child; i++) {
  const childAgeGroup = JSON.parse(JSON.stringify(this.ageGroupList.find(item => item.id === 'CHD')));
  childAgeGroup.selectedByUser = true;
  this.searchService.ageGroupArray.push(childAgeGroup);
  }
  
  // Add infants
  for (let i = 0; i < this.guestCounts.infant; i++) {
  const infantAgeGroup = JSON.parse(JSON.stringify(this.ageGroupList.find(item => item.id === 'INF')));
  infantAgeGroup.selectedByUser = true;
  this.searchService.ageGroupArray.push(infantAgeGroup);
  }
  }
  
  // Clear cache to reflect changes
  this.ageGroupCache.clear();
  }
  
  restoreGuestCounts() {
  // Restore guest counts from ageGroupArray when editing trip
  if (!this.searchService.ageGroupArray || this.searchService.ageGroupArray.length === 0) {
  return;
  }
  
  if(this.viewMode==='tab3' && this.searchService.ageGroupArray.length > 1){
    this.searchService.ageGroupArray.splice(1);
  }
  
  // Find how many non-guest travelers we have
  const nonGuestCount = this.searchService.employeeEmail.filter(t => t.email !== 'GUEST').length;
  
  // Reset counts
  this.guestCounts = { adult: 0, child: 0, infant: 0 };
  
  // Count guest age groups from the ageGroupArray
  for (let i = 0; i < this.searchService.ageGroupArray.length; i++) {
   const employee = this.searchService.employeeEmail[i];
  const ageGroup = this.searchService.ageGroupArray[i];
   if(employee && employee.email === 'GUEST'){
     if (ageGroup && ageGroup.id) {
       if (ageGroup.id === 'ADT') {
       this.guestCounts.adult++;
       } else if (ageGroup.id === 'CHD') {
       this.guestCounts.child++;
       } else if (ageGroup.id === 'INF') {
       this.guestCounts.infant++;
       }
     }
   }
  }
  }
  
  getTotalPassengerCount(): number {
  // Return total count including guest travelers
  if (!this.searchService.employeeEmail) {
  return 0;
  }
  
  // Count non-guest travelers
  const nonGuestCount = this.searchService.employeeEmail.length;
  
  // Add guest counts if guest traveler is selected
  const guestTotal = this.isGuestTravelerSelected()
  ? (this.guestCounts.adult + this.guestCounts.child + this.guestCounts.infant)
  : 0;

  return nonGuestCount ;
  }
  
  updatePassengerCount() {
  const totalCount = this.getTotalPassengerCount();

  
  this.travelerApplied.emit({
      passengers: this.getTotalPassengerCount(),
      travelers: this.searchService.employeeEmail
    });
  }
  
  getTravelerAgeGroup(traveler: any): any {
  if (!traveler) return null;
  
  const travelerEmail = traveler.email || traveler.userId;
  
  // Check cache first to avoid repeated calculations
  if (this.ageGroupCache.has(travelerEmail)) {
  return this.ageGroupCache.get(travelerEmail);
  }
  
  const index = this.searchService.employeeEmail.findIndex(t =>
  (t.email === travelerEmail) || (t.Id === traveler.employeeIdentifier && t.Name === traveler.userName)
  );
  
  let ageGroup = null;
  if (index > -1 && this.searchService.ageGroupArray && this.searchService.ageGroupArray[index]) {
  ageGroup = this.searchService.ageGroupArray[index];
  }
  
  // Cache the result
  this.ageGroupCache.set(travelerEmail, ageGroup);
  return ageGroup;
  }
  getLabelPassengerType(traveler){
  
  
  if(this.getTravelerAgeGroup(traveler)){
  return this.getTravelerAgeGroup(traveler).label
  }
  return 'Select passenger type';
  
  }
  setTravelerAgeGroup(traveler: any, ageGroupId: string) {
  if (!traveler) return;
  if(traveler && traveler.dob){
  return
  }
  const travelerEmail = traveler.email || traveler.userId;
  const index = this.searchService.employeeEmail.findIndex(t =>
  (t.email === travelerEmail) || (t.Id === traveler.employeeIdentifier && t.Name === traveler.userName)
  );
  
  if (index > -1) {
  const ageGroup = this.ageGroupList.find(item => item.id === ageGroupId);
  if (ageGroup) {
  // Initialize ageGroupArray if needed
  if (!this.searchService.ageGroupArray) {
  this.searchService.ageGroupArray = [];
  }
  // Ensure array is same length as employeeEmail
  while (this.searchService.ageGroupArray.length < this.searchService.employeeEmail.length) {
  const defaultAgeGroup = JSON.parse(JSON.stringify(this.ageGroupList[0]));
  defaultAgeGroup.superAdult = true;
  this.searchService.ageGroupArray.push(defaultAgeGroup);
  }
  // Set age group at the same index as traveler in employeeEmail
  const selectedAgeGroup = JSON.parse(JSON.stringify(ageGroup));
  selectedAgeGroup.superAdult = true; // Mark as super adult when selected
  selectedAgeGroup.selectedByUser = true;
  this.searchService.ageGroupArray[index] = selectedAgeGroup;
  
  
  // Clear cache for this traveler to reflect the change
  this.ageGroupCache.delete(travelerEmail);
  }
  }
  }
  
  // Check if traveler needs passenger type selection
  needsPassengerTypeSelection(traveler: any): boolean {
  if (!this.searchService.infantBookingAllowed) return false;
  if (this.viewMode !== 'tab1' && this.viewMode !== 'tab5') return false;
  if (!traveler || traveler.dob) return false;
  
  return this.isTravelerSelected(traveler);
  }
  
  // Check if traveler has incomplete passenger type (selected but no age group)
  hasIncompletePassengerType(traveler: any): boolean {
  if (!this.needsPassengerTypeSelection(traveler)) return false;
  
  const ageGroup = this.getTravelerAgeGroup(traveler);
  return !ageGroup || !ageGroup.id;
  }
  
  calculateAgeGroupFromDOB(dateOfBirth: string): any {
  if (!dateOfBirth) return JSON.parse(JSON.stringify(this.ageGroupList[0])); // Default to Adult
  
  const dob = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
  age--;
  }
  
  if (age < 2) {
  return JSON.parse(JSON.stringify(this.ageGroupList[2])); // INF
  } else if (age >= 2 && age < 12) {
  return JSON.parse(JSON.stringify(this.ageGroupList[1])); // CHD
  } else {
  return JSON.parse(JSON.stringify(this.ageGroupList[0])); // ADT
  }
  }
  
  // Rebuild ageGroupArray to match employeeEmail array
  rebuildAgeGroupArray() {
  if (!this.searchService.infantBookingAllowed) {
  return;
  }
  
  let newAgeGroupArray = this.searchService.ageGroupArray
  let index = 0 ; 
  this.searchService.ageGroupArray = [];
  if (this.searchService.employeeEmail && this.searchService.employeeEmail.length > 0) {
  for (let traveler of this.searchService.employeeEmail) {
  // Skip GUEST travelers
  if (traveler.email === 'GUEST'){
    this.searchService.ageGroupArray.push(newAgeGroupArray[index]);
    index++
    continue;
  } 
  
  // Find traveler in travellerList to get DOB
  const travelerInfo = (this.searchService.travellerList || []).find(t => t.userId === traveler.email);
  if (travelerInfo && (travelerInfo.dateOfBirth || travelerInfo.dob)) {
  const ageGroup = this.calculateAgeGroupFromDOB(travelerInfo.dob);
  ageGroup.superAdult = true;
  this.searchService.ageGroupArray.push(ageGroup);
  } else {
  // No DOB - add placeholder without selecting any age group
  this.searchService.ageGroupArray.push({ id: null, superAdult: false });
  }
  }
  index++
  }
  }

 
  get travelerModal() {
    return {
      close: () => {
        this.searchService.showTravelerDropDown = false;
      }
    };
  }

  applyTravelerSelection() {
    this.searchService.showTravelerDropDown = false;
  }

  
  @HostListener('document:click', ['$event'])
onOutsideClick(event: MouseEvent) {
  if (
    this.searchService.showTravelerDropDown &&
    !this.elRef.nativeElement.contains(event.target)
  ) {
    this.searchService.showTravelerDropDown = false;
  }
}

      searchStringCheck(search){
          if (!this.travelerSearchTerm || this.travelerSearchTerm.trim() === '') {
          return true;
          }
          

        const searchTerm = this.travelerSearchTerm.toLowerCase();
        let name = search.toLowerCase();
        if(search == 'Myself'){
           name = this.translateService.instant('search.Myself').toLowerCase();
        }
        return name.includes(searchTerm);
      }
      
}
